module.exports = __webpack_public_path__ + "static/img/s_4.08705509.png";